module.exports = __webpack_public_path__ + "static/media/pasta.2b61a99f.png";